import { ZExtensionType } from "./ZExtension";

export const isBusinessRuleType = (
  type: ZExtensionType | null | undefined,
): boolean => type === "BUSINESS_RULE";
